import _ from 'lodash';
import { createSelector } from 'reselect';
import { getQuestions } from './core';
import { getSelectedProfile } from './profiles';

const getQuestionsForSelectedProfile = createSelector(
  getQuestions,
  getSelectedProfile,
  (questions, profile) =>
    _.chain(questions)
      .filter(question => question.profileId === profile.id)
      .sortBy('createdAt')
      .value()
);

const getUnansweredQuestions = createSelector(
  getQuestionsForSelectedProfile,
  questions => _.filter(questions, question => !question.answered)
);

// Returns the 2 latest questions
const getRecentUnansweredQuestions = createSelector(
  getUnansweredQuestions,
  questions =>
    _.chain(questions)
      .sortBy('createdAt')
      .takeRight(2)
      .value()
);

export {
  getQuestionsForSelectedProfile,
  getUnansweredQuestions,
  getRecentUnansweredQuestions
};



// WEBPACK FOOTER //
// ./src/selectors/questions.js